import React from 'react';

export default function ValidationRuleBuilder({ value, onChange }) {
  const rules = value || {};

  function update(next) {
    onChange(next);
  }

  return (
    <div className="space-y-3">
      <div className="text-xs font-semibold text-gray-600 dark:text-slate-400">Validation Rules</div>
      <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-slate-200">
        <input
          type="checkbox"
          checked={!!rules.required}
          onChange={(e) => update({ ...rules, required: e.target.checked })}
          className="w-4 h-4"
        />
        Required
      </label>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <input
          type="number"
          placeholder="Min"
          value={rules.min ?? ''}
          onChange={(e) => update({ ...rules, min: e.target.value === '' ? null : Number(e.target.value) })}
          className="w-full px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
        />
        <input
          type="number"
          placeholder="Max"
          value={rules.max ?? ''}
          onChange={(e) => update({ ...rules, max: e.target.value === '' ? null : Number(e.target.value) })}
          className="w-full px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
        />
      </div>
      <input
        type="text"
        placeholder="Regex pattern"
        value={rules.pattern ?? ''}
        onChange={(e) => update({ ...rules, pattern: e.target.value || null })}
        className="w-full px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
      />
      <input
        type="text"
        placeholder="Custom error message"
        value={rules.message ?? ''}
        onChange={(e) => update({ ...rules, message: e.target.value || null })}
        className="w-full px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
      />
    </div>
  );
}


